import _ from 'lodash';
import axios from 'axios';

const base = '/api/v1/lwadmin/series';

export function getAllSeries(filter) {
  return axios.get(`${base}`, {
    cache: { ignoreCache: true },
    params: { filter: filter || 'all' },
  });
}

export function getById(id) {
  return axios.get(`${base}/${id}`, { cache: { ignoreCache: true } });
}

export function deleteById(id) {
  return axios.delete(`${base}/${id}`);
}

export function createOrUpdate(series) {
  return axios.post(
    `${base}/${_.get(series, 'id', '')}`,
    _.pick(series, ['title', 'slug', 'description']),
  );
}

export function archive(id) {
  return axios.post(`${base}/${id}/archive`);
}

export function unarchive(id) {
  return axios.post(`${base}/${id}/unarchive`);
}
